import type { StripRow } from '@/lib/today';
import { delta, num, when } from '@/lib/format';
import s from '@/pages/console/console.module.css';

/**
 * The five funnel numbers with the prior-week comparison. Every value is a
 * row count the digest took; the 24 h number is the small print because the
 * week is the number that means something for a new organisation.
 */
export function StatusStrip({ rows, generatedAt }: { rows: StripRow[]; generatedAt: string | null }) {
  return (
    <div>
      <div className={s.strip}>
        {rows.map((r) => {
          const d = delta(r.last7d, r.prior7d);
          return (
            <div key={r.key} className={s.stat}>
              <span className={s.statLabel}>{r.label}</span>
              <span className={s.statVal}>{num(r.last7d)}</span>
              <span className={`${s.statDelta} ${s[d.dir]}`}>{d.label}</span>
              <span className={s.statSub}>{num(r.last24h)} in the last 24 h</span>
            </div>
          );
        })}
      </div>
      <div className={s.sub} style={{ marginTop: 6 }}>
        Last 7 days, accounts created in the window. Measured {generatedAt ? when(generatedAt) : 'not measured'}.
      </div>
    </div>
  );
}
